export enum TermsAndConditions {
  TERMS_AND_CONDITIONS = 'https://cdn.wecheck.ai/WeCheck/public-static/legal-docs/TermsOfUse-EN.pdf',
}

export enum PrivacyPolicy {
  PRIVACY_POLICY = 'https://cdn.wecheck.ai/WeCheck/public-static/legal-docs/PrivacyPolicy-EN.pdf',
}

export enum CCPANotice {
  CCPA_NOTICE = 'https://cdn.wecheck.ai/WeCheck/public-static/legal-docs/CCPA-EN.pdf',
}

export enum TermsAndConditionsSpanish {
  TERMS_AND_CONDITIONS_SPANISH = 'https://cdn.wecheck.ai/WeCheck/public-static/legal-docs/TermsOfUse-ES.pdf',
}

export enum PrivacyPolicySpanish {
  PRIVACY_POLICY_SPANISH = 'https://cdn.wecheck.ai/WeCheck/public-static/legal-docs/PrivacyPolicy-ES.pdf',
}
